import { render, staticRenderFns } from "./ScaleSelection.vue?vue&type=template&id=962a7314&scoped=true&"
import script from "./ScaleSelection.vue?vue&type=script&lang=ts&"
export * from "./ScaleSelection.vue?vue&type=script&lang=ts&"
import style0 from "./ScaleSelection.vue?vue&type=style&index=0&id=962a7314&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "962a7314",
  null
  
)

export default component.exports